import React from 'react';
import LoadingSpinner from '../LoadingSpinner';

const BankDetailsSection = ({
  stripeOnboardingStatus,
  bankDetailsMessage,
  isLoadingBankDetails,
  handleUpdateBankDetails,
  handleStartStripeOnboarding,
  signupMethod
}) => {
  return (
    <div className={`bg-white rounded-lg p-6 text-black ${signupMethod === 'google' ? 'h-full flex flex-col md:justify-center' : ''}`}>
      <h2 className="text-xl font-semibold mb-4">
        {stripeOnboardingStatus === 'complete' ? 'Update bank details' : 'Set up payments'}
      </h2>
      
      <div className="space-y-4">
        <p className="">
          {stripeOnboardingStatus === 'complete' 
            ? 'Update your bank account and other financial details through Stripe\'s secure dashboard.'
            : 'Set up your account to receive payments through Stripe. This will allow your supporters to tip you using credit cards and other payment methods.'}
        </p>
        
        {bankDetailsMessage.text && (
          <div className={`text-center ${bankDetailsMessage.type === 'success' ? 'text-green-500' : 'text-red-500'}`}>
            {bankDetailsMessage.text}
          </div>
        )}
        
        <div className="flex justify-center">
          <button
            onClick={stripeOnboardingStatus === 'complete' ? handleUpdateBankDetails : handleStartStripeOnboarding}
            className={`px-4 py-2 font-semibold rounded transition-colors duration-200 ${
              !isLoadingBankDetails
                ? 'bg-green-500 text-white hover:bg-green-600'
                : 'bg-gray-300 text-gray-500 cursor-not-allowed'
            }`}
            disabled={isLoadingBankDetails}
          >
            {isLoadingBankDetails ? (
              <>
                Loading
                <LoadingSpinner className="inline-block ml-2 w-4 h-4" />
              </>
            ) : (
              stripeOnboardingStatus === 'complete' ? 'Update bank details' : 'Set up payments'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BankDetailsSection;
